import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestForwardEndpointsGet = {
    path: "/forward/endpoints",
    method: RouteHttpVerb.GET
};
